"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Mailer;
    }
});
const _mailersend = /*#__PURE__*/ _interop_require_wildcard(require("mailersend"));
const _ncError = require("~/helpers/ncError");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
let Mailer = class Mailer {
    async init() {
        var _this_input;
        this.mailersend = new _mailersend.default({
            api_key: (_this_input = this.input) == null ? void 0 : _this_input.api_key
        });
    }
    async mailSend(mail) {
        const recipients = [
            new _mailersend.Recipient(mail.to)
        ];
        const emailParams = new _mailersend.EmailParams().setFrom(this.input.from).setFromName(this.input.from_name).setRecipients(recipients).setSubject(mail.subject).setHtml(mail.html).setText(mail.text);
        const res = await this.mailersend.send(emailParams);
        if (res.status === 401) {
            throw new Error(res.status);
        }
    }
    async test(email) {
        try {
            await this.mailSend({
                to: email,
                subject: 'Test email',
                html: 'Test email'
            });
            return true;
        } catch (e) {
            _ncError.NcError._.pluginTestError(e == null ? void 0 : e.message);
        }
    }
    constructor(input){
        this.input = input;
    }
};
